import { useQuery } from '@tanstack/react-query';

import { FreelancerRoleResource } from '@/types/resources';
import { api } from '@/utils/api';

const useFreelancerRolesOptions = () => {
  return useQuery(
    ['freelancer_roles'],
    () => api.get<never, FreelancerRoleResource[]>('/v1/freelancer-roles'),
    {
      select: (data) =>
        data.map((item) => ({
          value: item.id,
          label: item.name,
          hide_from_dropdowns: item.hide_from_dropdowns,
        })),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
};

export default useFreelancerRolesOptions;
